import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useMsal } from '@azure/msal-react';
import { API_REQUEST, API_SUCCESS, API_ERROR } from './action-types';

import { assert } from '../utils';
import { updateAuth, resetApiStatus, setApiError } from './actions';
import errors from '../config/errors';
import store, { dispatch } from '../root/store';
import { msalInstance, loginRequest, storeToken, b2cScopes } from '../config/msal-auth';

let errorTimeout = null;
let isIgnoreSuccessReset = false;

function resetError() {
  dispatch(resetApiStatus());
  errorTimeout = null;
  if (isIgnoreSuccessReset) isIgnoreSuccessReset = false;
}

const getNewToken = (dispatch, action) => {
  const { accounts } = useMsal();
  let originalSignInAccount = undefined;
  if (accounts.length > 1) {
    // Add your account choosing logic here
    originalSignInAccount = msalInstance
      .getAllAccounts()
      .find((account) => account?.idTokenClaims['tfp']?.toUpperCase() === 'B2C_1_signIn_signUp'.toUpperCase());
  } else if (accounts.length === 1) {
    originalSignInAccount = accounts[0]

  }

  if (originalSignInAccount) {
    msalInstance
      .acquireTokenSilent({
        account: msalInstance.getAccountByHomeId(originalSignInAccount.homeAccountId),
        scopes: b2cScopes,
      })
      .then(response => {
        storeToken(response.accessToken);
        dispatch(action);
      })
      .catch(e => {
        if (e instanceof InteractionRequiredAuthError) {
          // fallback to interaction when silent call fails
          msalInstance.acquireTokenRedirect(originalSignInAccount.homeAccountId)
        } else {
          console.log(e);
        }

      });
  }
};

const middleware = () => next => action => {
  switch (action.type) {
    case API_SUCCESS: {
      isIgnoreSuccessReset = action?.meta?.ignoreSuccessReset || false
      // Dont set API store to SUCCESS on next API call (in case error request is immediately followed by successful request)
      if (errorTimeout !== null && !isIgnoreSuccessReset) {
        clearTimeout(errorTimeout);
        errorTimeout = null;
      }
      if (!isIgnoreSuccessReset) resetError();
      dispatch(updateAuth(action.payload, action.meta));

      return next(action);
    }
    case API_ERROR: {
      // Set timeout for error message unless told otherwise
      if (errorTimeout !== null) {
        clearTimeout(errorTimeout);
        errorTimeout = null;
      }
      if (!action.meta || (action.meta && !action.meta.isIgnoreTimeout)) {
        errorTimeout = setTimeout(resetError, 20000);
        if (action.meta && action.meta.isIgnoreSuccessReset) {
          isIgnoreSuccessReset = true;
        }
      }

      // 'Unauthorized' error
      if (action?.meta?.status === 401 && action?.error !== 'Invalid login') {
        // getNewToken(dispatch, action.meta.requestAction);
      }

      // Humanize error messages depending on your page. There should be a better way to do this.
      if (store.getState().router && store.getState().router.location) {
        const { pathname } = store.getState().router.location;

        if (action.meta && action.meta.status) {
          if (pathname === '/phone') {
            action.error = 'The phone number you entered was invalid.';
          } else if (pathname === '/passcode') {
            action.error = 'The confirmation code you entered was invalid.';
          } else if (pathname === '/activation') {
            action.error = 'The private beta password you entered was invalid.';
          } else if (pathname === '/upcoming/terms') {
            action.error = 'The payment information you entered was invalid.';
          }
        }
      }

      return next(action);
    }
    case API_REQUEST: {
      // const ignoreAuth = action.meta && action.meta.ignoreAuth
      // const auth = store.getState().api.get('auth')
      // const lastQueried = store.getState().api.get('lastQueried')

      // // Ignore checking for auth if specified (login routes)
      // if (!ignoreAuth && auth) {
      //   const authExpired = !(lastQueried + auth.expiresIn > Date.now())
      //   if (authExpired) {
      //     dispatch(
      //       logout({
      //         actionAfterLogout: () =>
      //           setApiError('Your session has expired. Please login again.', {
      //             isIgnoreTimeout: true
      //           })
      //       })
      //     )
      //   }
      // }

      // Run assertion on request before hand
      if (action.meta && action.meta.assert) {
        const { item, test } = action.meta.assert;
        const hasError = !assert[test](item);
        if (hasError) {
          action.meta.assert.hasError = hasError;
          action.meta.assert.error = errors.assert;
        }
      }
      return next(action);
    }
    default: {
      return next(action);
    }
  }
};

export default middleware;
